import { useAuth } from "@/context/AuthContext";
import AccessDenied from "@/components/AccessDenied";

// Authenticated-but-authorized gate. ProtectedRoute has already guaranteed the
// user is logged in; here we only check role. Lacking a role shows 403 — it
// must never bounce the user back to the login screen.
export default function RequireRole({ roles, children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (roles && roles.length && !roles.includes(user.role)) return <AccessDenied />;
  return children;
}
